module.exports = __webpack_public_path__ + "img/relatorios.08ae14b7.svg";